import React from 'react';
import {InputLabel} from 'material-ui';
import SimpleEditor from "../../../components/editor/simple_editor";

const MapLocationField = ({label, description, locationId, onUpdateSectionLocation}) => {
    return (
        <div>
            <InputLabel className="simpleEditorLabelPages">{label}</InputLabel>
            <SimpleEditor
                initialValue={description}
                onChange={(htmlBody) => {
                    onUpdateSectionLocation(locationId, htmlBody)
                }}
            />
        </div>
    );
};

export default MapLocationField;


// WEBPACK FOOTER //
// ./src/containers/builder/form/map_location_field.js